import classNames from "classnames";
function Form({children,className,...rest}){
    const classnames = classNames('',className);
    return(
        <form className={classnames} {...rest}>
                {children}
        </form>
 )   
}
export default Form;